import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";


export const PurchaseDealerProfitInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Profit Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        Vehicle Profit
                    </Text>
                    <Text>{pdfData.vehicle_profit.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}